<sh-form-tag-list-base
    *ngIf="filter()"
    [formControl]="tagValuesControl"
    [placeholder]="$placeholder()"
    [styling]="$tagStyling()"
    [droppanelStyle]="$droppanelStyling()"
    [actionItem]="$actionItem()"
    [autocompleteFct]="$autoCompleteFct()"
    [singleTag]="$singleTag()"
    [editable]="true"
>
</sh-form-tag-list-base>
